document.querySelectorAll('[data-faq-page]').forEach((page) => {
  const input = page.querySelector('[data-faq-filter]');
  const clear = page.querySelector('[data-faq-clear]');
  const empty = page.querySelector('[data-faq-empty]');
  const items = [...page.querySelectorAll('[data-faq-item]')];
  const groups = [...page.querySelectorAll('[data-faq-group]')];
  const categoryLinks = [...page.querySelectorAll('[data-faq-category-link]')];

  items.forEach((item) => {
    const summary = item.querySelector('summary');
    if (!summary) return;

    const syncExpandedState = () => {
      summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
    };

    syncExpandedState();
    item.addEventListener('toggle', syncExpandedState);
  });

  const setCurrentCategory = (activeLink) => {
    categoryLinks.forEach((link) => {
      if (link === activeLink) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  const syncCurrentCategoryFromHash = () => {
    const activeLink = categoryLinks.find((link) => link.hash === window.location.hash);
    if (activeLink) setCurrentCategory(activeLink);
  };

  categoryLinks.forEach((link) => {
    link.addEventListener('click', () => setCurrentCategory(link));
  });
  syncCurrentCategoryFromHash();

  if (!input || !clear || !empty || !items.length) return;

  const filter = () => {
    const query = input.value.trim().toLocaleLowerCase();
    let matches = 0;

    items.forEach((item) => {
      const visible = !query || item.textContent.toLocaleLowerCase().includes(query);
      item.hidden = !visible;
      if (visible) matches += 1;
    });

    groups.forEach((group) => {
      group.hidden = !group.querySelector('[data-faq-item]:not([hidden])');
    });
    clear.hidden = !query;
    empty.hidden = matches > 0;
  };

  input.addEventListener('input', filter);
  clear.addEventListener('click', () => {
    input.value = '';
    filter();
    input.focus();
  });
});
